import {globalError} from "modules/actions";
import {fetchLeaders, fetchLeadersFailed, fetchLeadersSuccess} from "modules/actions/leaders";
import {getSentryUser} from "modules/selectors";
import {getLeadersCollection} from "modules/selectors/leaders";
import Api from "modules/utils/Api";
import ApiError from "modules/utils/Api/ApiError";
import {captureSentryError} from "modules/utils/sentry";
import {call, put, select} from "typed-redux-saga";

export const fetchLeadersSaga = function* (action: ReturnType<typeof fetchLeaders>) {
	try {
		const leaders = yield* select(getLeadersCollection);

		const response = yield* call(Api.Prediction.leaders, {
			page: action.payload.page,
		});

		ApiError.CHECK(response.data);

		const isFirstPage = action.payload.page === 1;

		const leadersArray = isFirstPage
			? response.data.success.leaders
			: [...leaders.leaders, ...response.data.success.leaders];

		yield* put(
			fetchLeadersSuccess({
				leaders: leadersArray,
				nextPage: response.data.success.nextPage,
			})
		);
	} catch (e) {
		const user = yield* select(getSentryUser);
		captureSentryError("fetchLeaderSaga", "none", e, user);
		yield* put(globalError(e));
		yield* put(fetchLeadersFailed());
	}
};
